var _G, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";
var SvgReport = function SvgReport(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 22,
    fill: "none",
    viewBox: "0 0 25 22"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#report_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#FF4D3D",
    d: "M9.87 1.286.35 17.642c-.998 1.715.25 3.858 2.246 3.858h19.037c1.995 0 3.243-2.144 2.245-3.858L14.36 1.286c-.998-1.715-3.493-1.715-4.49 0L.35 17.642c-.998 1.715.25 3.858 2.246 3.858h19.037c1.995 0 3.243-2.144 2.245-3.858L14.36 1.286c-.998-1.715-3.493-1.715-4.49 0"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: "#4A1A0E",
    d: "M12.114 14.666c-1.404 0-1.954-4.85-2.008-7.896 0-1.087.888-1.967 1.983-1.967h.052c1.095 0 1.983.88 1.983 1.967 0 0-.398 7.988-2.01 7.896M12.115 18.413c.72 0 1.303-.578 1.303-1.292s-.583-1.293-1.303-1.293-1.303.579-1.303 1.293.583 1.292 1.303 1.292"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "report_svg__a"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M0 0h24.23v21.5H0z"
  })))));
};
export default SvgReport;